<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title>
      <!--      <span class="headline">{{ dealer.name }}</span>-->
      <span class="headline">Объект № {{objectId}}</span>
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="back">Назад</v-btn>
    </v-card-title>
    <v-tabs
        v-model="tab"
        color="green"
        :grow="true"
    >
      <v-tab
          v-for="item in items"
          :key="item.tab"
          :disabled="item.disabled"
          class="inactive-tab"
          active-class="active-tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
          v-for="item in items"
          :key="item.tab"
      >
        <component
            :key="objectId"
            :is="item.component"
            v-bind="{objectId}"
            @ready="loading = false"
        ></component>
      </v-tab-item>
    </v-tabs-items>

    <v-overlay
        :value="loading"
        absolute
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
// import API from "@/axios/api";
import ObjectEdit from "@/components/Object/ObjectEdit";
import ObjectMasters from "@/components/Object/ObjectMasters";

export default {
  name: 'Object',
  props: ['objectId'],
  components: {
    ObjectEdit,
    ObjectMasters,
  },
  data() {
    return {
      loading: true,
      tab: 0,
      // dealer: {},
      items: [
        {
          tab: 'Свойства',
          component: 'ObjectEdit',
        },
        {
          tab: 'Мастер-лицензии',
          component: 'ObjectMasters',
        },
      ],
    }
  },
  methods: {
    back() {
      history.back();
    },
    // async getMasterData() {
    //   await API.get(`masters/${this.masterId}`)
    //       .then((response) => {
    //         console.log(response.data);
    //         this.dealer = response.data.dealer;
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    // },
  },
  watch: {
    objectId: function () {
      this.tab = 0;
      this.loading = true;
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'objects', disabled: false, to: '/objects', exact: true},
      {text: this.objectId, disabled: true},
    ])
    // this.getMasterData().then(() => this.loading = false);
  },
}
</script>